export default class Freelance {
  constructor(data) {
    this.id = data.id || "";
    this.title = data.title || "";
    this.cleanText = data.clean_text || "";
    this.actionUrl = data.action_url || "";
    this.freelanceType = data.freelance_type || "";
    this.contactType = data.contact_type || "";
    this.hashtags = data.hashtags || [];
    this.uniqueId = data.unique_id || "";

    this.date = data.date_of_create
      ? new Date(data.date_of_create * 1000)
      : null;
  }

  get formattedDate() {
    if (!this.date) return "";
    return this.date.toLocaleDateString("ru-RU", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  get shortText() {
    const text = this.cleanText || "";
    return text.length > 140 ? text.slice(0, 140) + "..." : text;
  }

  // --- ВОТ ТУТ ИКОНКА ---
  get contactIcon() {
    switch (this.contactType) {
      case "telegram": return "../../../assets/freelance_tg.png";
      case "email": return "../../assets/freelance_email.png";
      case "google": return "../../assets/freelance_google.png";
      case "yandex": return "../../assets/freelance_yandex.png";
      default: return null;
    }
  }
}